import { Props } from '@/shared/types/icon';

export const NumbersIcon = ({ size = 24, color = 'currentColor' }: Props) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 19.496c2 1.113 4 .222 4-1.114 0-.394-.21-.772-.586-1.05-.375-.278-.884-.435-1.414-.435.53 0 1.04-.156 1.414-.435.375-.278.586-.656.586-1.05 0-1.113-1.8-1.856-3.5-1.113M10 6a2 2 0 1 0-4 0v2a2 2 0 1 0 4 0V6ZM14 10h4m-4-6h2v6M10 20H6c0-3.1 4-2.325 4-4.65 0-1.162-2-1.937-4-.775"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
